import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SampleService } from 'src/app/services/sample.service';
import { ToastService } from 'src/app/services/toast.service';
import { TranslateService } from 'src/app/services/translate.service';

export interface UnlinkCocDialogData {
  sampleNumber: string;
  labReqNumber: string;
  sampleId: string;
}

@Component({
  standalone: false,
  selector: 'app-unlink-coc-dialog',
  templateUrl: './unlink-coc-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./unlink-coc-dialog.component.scss']
})
export class UnlinkCocDialogComponent {
  isLoading = false;
  errorMessage: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<UnlinkCocDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UnlinkCocDialogData,
    private sampleService: SampleService,
    private toastService: ToastService,
    private translateService: TranslateService
  ) { }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onUnlink(): void {
    if (this.isLoading || !this.data.sampleId) return;

    this.isLoading = true;
    this.errorMessage = null;

    this.sampleService.unlinkFromCoc(this.data.sampleId).subscribe({
      next: () => {
        this.isLoading = false;
        this.toastService.showSuccess(
          'Sample {{sampleNumber}} unlinked from COC',
          true,
          { sampleNumber: this.data.sampleNumber }
        );
        this.dialogRef.close(true);
      },
      error: (error) => {
        this.isLoading = false;
        const errorMsg = error?.error?.message ||
          (error?.status === 409
            ? this.translateService.getDynamicTranslation('This sample cannot be unlinked at this time')
            : error?.message) ||
          this.translateService.getDynamicTranslation('Failed to unlink sample from COC');
        this.errorMessage = errorMsg;

        if (error?.status !== 409) {
          this.toastService.showError(errorMsg);
        }
      }
    });
  }
}
